import { AfterViewInit, Component, inject } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ReportService } from '@services/report/report.service';
import { ReportRequest } from '@interfaces/report';
import { ActivatedRoute, Router } from '@angular/router';
import { TagComponent } from '../../../components/tag/tag.component';
import { TranslatePipe } from '@ngx-translate/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSelectModule } from 'ng-zorro-antd/select';
import {MatOption, MatSelect} from '@angular/material/select';
import {take} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NzDividerComponent} from 'ng-zorro-antd/divider';

@Component({
  selector: 'app-requests',
  imports: [
    FormsModule,
    TagComponent,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    TranslatePipe,
    NzButtonModule,
    NzDropDownModule,
    NzIconModule,
    NzInputModule,
    NzTableModule,
    NzSpinModule,
    NzPaginationModule,
    NzSelectModule,
    NzDividerComponent
  ],
  templateUrl: './requests.component.html',
  standalone: true,
  styleUrl: './requests.component.scss'
})
export class RequestsComponent implements AfterViewInit {
  allRequests?: ReportRequest[];
  reportRequests?: ReportRequest[];
  listOfDisplayData: ReportRequest[] = [];
  statuses = ['REQUESTED', 'COMPLETED', 'IN_PROGRESS', 'REJECTED'];
  status = 'REQUESTED';

  // Pagination properties
  page = 1;
  pageSize = 10;
  total = 0;

  // Search properties
  searchValue = '';
  visible = false;

  private reportService = inject(ReportService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private _snackBar = inject(MatSnackBar);

  ngAfterViewInit() {
    this.getRequests();
  }

  getRequests() {
    this.reportService.requestsObservable$
      .subscribe((reportRequests: ReportRequest[]) => {
        this.allRequests = reportRequests;
        this.reportRequests = reportRequests;
        this.filterRequests();
        this.updateDisplayData();
      });
  }

  openRequests(request: ReportRequest) {
    this.router.navigate([`${request.id}`], { relativeTo: this.route });
  }

  filterRequests() {
    this.reportRequests = this.allRequests?.filter((request) => request.status === this.status);
    this.page = 1; // Reset to first page when filtering
    this.updateDisplayData();
  }

  updateDisplayData() {
    if (!this.reportRequests) {
      this.listOfDisplayData = [];
      this.total = 0;
      return;
    }

    let filteredData = [...this.reportRequests];

    // Apply search filter if there's a search value
    if (this.searchValue.length > 0) {
      filteredData = filteredData.filter((request: ReportRequest) =>
        request.requested_by.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
        request.requested_for.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
      );
    }

    this.total = filteredData.length;

    // Apply pagination
    const startIndex = (this.page - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.listOfDisplayData = filteredData.slice(startIndex, endIndex);
  }

  onPageChange(page: number): void {
    this.page = page;
    this.updateDisplayData();
  }

  reset(): void {
    this.searchValue = '';
    this.page = 1;
    this.updateDisplayData();
  }

  search(): void {
    this.visible = false;
    this.page = 1; // Reset to first page when searching
    this.updateDisplayData();
  }

  deleteRequest(id: string) {
    this.reportService.deleteReportRequest(id)
      .pipe(take(1))
      .subscribe((res: any) => {
        this._snackBar.open('Request deleted successfully', 'Close', {
          duration: 3000,
          panelClass: ['snackbar-success']
        });
    });
  }
}
